import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "./App.tsx";
import CallerV2 from "./bingo-v2/CallerV2.tsx";
import StagePage from "./bingo-v2/StagePage.tsx";
import "./index.css";
import "./bingo-v2/hall.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CallerV2 />} />
        <Route path="/stage/*" element={<StagePage />} />
        <Route path="/v1/*" element={<App />} />
        <Route path="/v2/*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
